import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Code from '../../particles/code'
import { Defaults } from '@styles/theme'
import { Theme } from '@styles/theme'
import { parseMarginOrPadding } from '@helpers'

const propTypes = {}

const FormulaComponent = ({ children, className, ...rest }) => {
  return (
    <Code as="div" className={className} {...rest}>
      ƒ {children}
    </Code>
  )
}

FormulaComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
}

const Formula = styled(FormulaComponent)`
  margin: ${({ margin }) => parseMarginOrPadding(margin, '0 0 1rem 0')};
  color: ${Theme.palette.text[200]};
  border-radius: ${Defaults.borderRadius};
  :last-child {
    margin-bottom: 0rem;
  }
`

Formula.propTypes = propTypes
export default Formula
